// src/constants/urls.js
export const URLs = {
  INSTALL: "/install",
  USERS: "/",
  CODE: "/code",
  LOTTERY: "/lottery",
  CASH: "/cash",
  MESSAGE: "/message",
  REWARD: "/reward",
  OUTBOX: "/outbox",
  CAMPAIGN: "/campaign",
  CHART: "/chart",
  LOGIN: "/login",
  REGISTER: "/register",
  VERIFICATION: "/verification",
  SERVICES: "/services",
  USER_INFORMATION: "/user-information/",
  ADD_QUESTION: "/add-question/",
  ChargeWithCode: "/ChargeWithCode/",
  AddGift: "/AddGift/",
  TOPUSERS: "/TopUsers/",
  TIKET: "/tiket/",
};
